import script from "./GstAudience.vue?vue&type=script&setup=true&lang=js"
export * from "./GstAudience.vue?vue&type=script&setup=true&lang=js"

import "./GstAudience.vue?vue&type=style&index=0&id=8bbc10aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bbc10aa"]])

export default __exports__